module.exports = __webpack_public_path__ + "img/dt.b03f6a15.png";